// extracted by mini-css-extract-plugin
export default {"box":"AccessDenied_box__tPU0O","state":"AccessDenied_state__53MKB","icon":"AccessDenied_icon__-ApLa","title":"AccessDenied_title__8MTBG","text":"AccessDenied_text__5XleL"};